import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import {
  SelectSingle,
  Props as SelectSingleProps,
} from '../../../apps/dashboard/components/Selects/SelectSingle';
import InputError from '../InputError';
import { getError } from '../utils';

type Props = Omit<SelectSingleProps, 'value' | 'onChange'> & {
  name: string;
};

export const SelectSingleControlled: React.FC<Props> = ({ name, ...props }) => {
  const { control, errors } = useFormContext();

  const error = getError(name, errors);

  return (
    <>
      <Controller
        as={({ value, onChange }) => {
          return (
            <SelectSingle
              {...props}
              value={value}
              onChange={onChange}
              error={error !== undefined}
              className={error ? 'is-invalid' : ''}
            />
          );
        }}
        name={name}
        control={control}
      />
      <InputError error={error} />
    </>
  );
};
